import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { get_select_one_reservation } from "../../Axios";
import * as S from "../../style/StyleComponentSection";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";

interface ReservationObject {
    brand_kor_name : string;
    product_name : string;
    color_name : string;
    construction_reservation_count : number;
    construction_reservation_high_status_name : string;
    construction_reservation_name : string;
    construction_reservation_address : string;
    construction_reservation_phone_number : string;
    construction_reservation_requests : string;
    construction_reservation_division_name : string;
    construction_reservation_reservationTime_format : string;
    construction_reservation_time_name : string;
    construction_reservation_pay : number;
    construction_reservation_division : number;
    construction_reservation_before_address : string;
}

const PaymentSuccess: React.FC = () => {
    const navigate = useNavigate();
    const {state} = useLocation();
    const [reservationList, setReservationList] = useState<ReservationObject[]>([]);
    const customerData = useSelector((state:RootState) => state.customerData);

    useEffect(() => {
        if(!customerData.customer_ID) return;
        if(!state) return;
        // 예약+동시결제(Reservation.tsx)는 ID 배열, 개별 결제(Payment.tsx)는 단일 ID로 진입
        const constructionReservationIDList: number[] = Array.isArray(state) ? state : [state];
        Promise.all(constructionReservationIDList.map(construction_reservation_ID => get_select_one_reservation(construction_reservation_ID))).then(results => {
            setReservationList(results.filter(Boolean));
        });
    }, [customerData.customer_ID, state]);

    return (
        <S.SectionContainer>
        <S.SectionWidth $width={1080}>
            <S.SectionTitleBox>
                <h1>결제완료</h1>
                <h3>수입조명 시공 전문 라이팅 인스톨러가 당신의 공간에 빛을 선물합니다.</h3>
            </S.SectionTitleBox>

            <div className="h-[50px]"></div>

            {reservationList.map((reservationOne, index) => (
            <React.Fragment key={index}>
            {index > 0 && <div className="h-[30px]"></div>}
            <S.SectionBorderContainer style={{padding : "10px 20px 10px 20px"}}>
                <div className="content-line">
                    <div className="label-box">브랜드</div>
                    <div className="content-box">{reservationOne?.brand_kor_name}</div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">제품명</div>
                    <div className="content-box pr-10 leading-[150%]">{reservationOne?.product_name} {reservationOne?.color_name}</div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">수량</div>
                    <div className="content-box">{reservationOne?.construction_reservation_count}개</div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">천장높이</div>
                    <div className="content-box">{reservationOne?.construction_reservation_high_status_name}</div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">고객명</div>
                    <div className="content-box">{reservationOne?.construction_reservation_name}</div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">주소</div>
                    <div className="content-box pr-10 leading-[150%]">{reservationOne?.construction_reservation_address}</div>
                </div>
                {reservationOne?.construction_reservation_division === 3 &&
                    <>
                        <hr />
                        <div className="content-line">
                            <div className="label-box">이전할 주소</div>
                            <div className="content-box pr-10 leading-[150%]">{reservationOne?.construction_reservation_before_address}</div>
                        </div>
                    </>
                }
                <hr />
                <div className="content-line">
                    <div className="label-box">전화번호</div>
                    <div className="content-box">{reservationOne?.construction_reservation_phone_number}</div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">요청사항</div>
                    <div className="content-box">
                        <div className="reservation-detail-request-item">
                            {reservationOne?.construction_reservation_requests}
                        </div>
                    </div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">구분</div>
                    <div className="content-box">{reservationOne?.construction_reservation_division_name}</div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">시공시간</div>
                    <div className="content-box">{reservationOne?.construction_reservation_reservationTime_format} {reservationOne?.construction_reservation_time_name}</div>
                </div>
                <hr />
                <div className="content-line">
                    <div className="label-box">예약 금액</div>
                    <div className="content-box">{reservationOne?.construction_reservation_pay.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}원</div>
                </div>
            </S.SectionBorderContainer>
            </React.Fragment>
            ))}

            <div className="mt-[50px] flex justify-center">
                <S.EmptyRoundedButton $btnSelect={false} $width={195} onClick={() => navigate('/reservation_detail')}>
                    예약 내역
                </S.EmptyRoundedButton>
                <S.EmptyRoundedButton $btnSelect $width={195} onClick={() => navigate('/main')}>
                    메인 페이지
                </S.EmptyRoundedButton>
            </div>

            <br />
            <br />

        </S.SectionWidth>
    </S.SectionContainer>
    )
};

export default PaymentSuccess;